<template>
    <div class="flex items-center text-sm font-medium cursor-pointer">
        <div @click="$emit('select', 'monthly')" class="flex-1 py-1.5 text-center border-2 border-r-0 rounded-l-lg" :class="{
                [`bg-${$root.theme}-400 border-${$root.theme}-200 text-white font-normal`]: frequency === 'monthly',
            }">
            Monthly
        </div>
        <div @click="$emit('select', 'biweekly')" class="flex-1 py-1.5 text-center border-2" :class="{
                [`bg-${$root.theme}-400 border-${$root.theme}-200 text-white font-normal`]: frequency === 'biweekly',
            }">
            Biweekly
        </div>
        <div @click="$emit('select', 'at-once')" class="flex-1 py-1.5 text-center border-2 border-l-0 rounded-r-lg" :class="{
                [`bg-${$root.theme}-400 border-${$root.theme}-200 text-white font-normal`]: frequency === 'at-once',
            }">
            At once
        </div>
    </div>
</template>
<script>
export default {
    props: ['frequency'],
}
</script>
